// extracted by mini-css-extract-plugin
module.exports = {"heroFoot":"hero-module--hero-foot--2exsI","hero":"hero-module--hero--1vdtE","heroBody":"hero-module--hero-body---IdkG"};